module.exports = __webpack_public_path__ + "static/img/new_home_1.cd78a0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_grande/new_home_1.jpg
// module id = s0VN
// module chunks = 1